<template>
  <div class="app-container">
    <!-- 查询表头 -->
    <el-form
      :model="queryParams"
      ref="queryForm"
      :inline="true"
      v-show="showSearch"
      label-width="90px"
    >
      <el-form-item label="兑换人" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入兑换人姓名"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="兑换手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入手机号"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 会员数据表格 -->
    <el-table v-loading="loading" :data="memberList">
      <el-table-column label="序号" align="center" type="index" width="50">
        <template slot-scope="scope">
          <span>{{
            (queryParams.page - 1) * queryParams.intPageSize + scope.$index + 1
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center" prop="TelPhone" />
      <el-table-column label="用户昵称" align="center" prop="WxUserInfoName" />
      <el-table-column label="兑换人" align="center" prop="UserName" />
      <el-table-column
        label="激活时间"
        align="center"
        prop="CreateTime"
        width="180"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="queryParams.intPageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>

<script>
import { getListMembers } from "@/api/cardHolder/member";

export default {
  name: "Member",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 会员表格数据
      memberList: [],
      // 查询参数
      queryParams: {
        page: 1,
        intPageSize: 10,
        phone: null,
        name: null,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询会员列表 */
    async getList() {
      this.loading = true;
      // 这里应该调用实际的API，以下是模拟数据
      const res = await getListMembers(this.queryParams);
      if (res.data.response.dataCount > 0) {
        this.memberList = res.data.response.data;
        this.total = res.data.response.dataCount;
        this.loading = false;
      } else {
        this.memberList = [];
        this.total = 0;
        this.loading = false;
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 查看详情按钮操作 */
    handleView(row) {
      this.$router.push({
        name: "会员明细",
        params: { userInfo: row },
      });
    },
    /** 分页-当前页数改变事件 */
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    /** 分页-每页显示条数改变事件 */
    handleSizeChange(val) {
      this.queryParams.intPageSize = val;
      this.getList();
    },
  },
};
</script>
